<template>
  <div>
    <!-- Botao flutuante para reabrir o menu quando ocultado -->
    <md-button
      v-if="!menuOpen"
      class="md-icon-button md-raised toggle-menu-button"
      :style="`top: ${y}px; right: ${x + railOffset}px;`"
      @click.stop="menuOpen = true"
    >
      <md-icon>menu</md-icon>
      <md-tooltip md-direction="left"> Mostrar menu </md-tooltip>
    </md-button>

    <div
      v-if="menuOpen"
      class="fixed-right"
      :class="{
        ['expanded']: expanded,
      }"
      :style="`top: ${y}px; right: ${x + railOffset}px;`"
    >
      <div class="card-slot">
        <div class="menu-header">
          <h2>Menu</h2>
          <md-button
            class="md-icon-button md-dense collapse-menu-button"
            @click.stop="menuOpen = false"
          >
            <md-icon>chevron_right</md-icon>
            <md-tooltip md-direction="left"> Ocultar menu </md-tooltip>
          </md-button>
        </div>

        <div class="menu-divider"></div>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.TimeSeriesView)"
        >
          <md-icon>show_chart</md-icon>
          <md-tooltip md-direction="left"> Gráficos de linha </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.GraphicalView)"
        >
          <md-icon>collections</md-icon>
          <md-tooltip md-direction="left"> Conjunto de imagens </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.ImageView)"
        >
          <md-icon>image</md-icon>
          <md-tooltip md-direction="left"> Imagem </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.TextView)"
        >
          <md-icon>text_fields</md-icon>
          <md-tooltip md-direction="left"> Texto </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.DialView)"
        >
          <md-icon>data_usage</md-icon>
          <md-tooltip md-direction="left"> Dial </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.ActionView)"
        >
          <md-icon>alarm</md-icon>
          <md-tooltip md-direction="left"> Ação </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.TabelaSensoresVirtuais)"
        >
          <md-icon>table_rows</md-icon>
          <md-tooltip md-direction="left"> Tabela </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem('pipeDrawing')"
        >
          <md-icon>polyline</md-icon>
          <md-tooltip md-direction="left"> Tubulação </md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem(ComponenteTipo.NavigationView)"
        >
          <md-icon>open_in_new</md-icon>
          <md-tooltip md-direction="left"> Navegação </md-tooltip>
        </md-button>

        <div class="menu-divider"></div>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => selectItem('saveDragPositions')"
        >
          <md-icon>save</md-icon>
          <md-tooltip md-direction="left"> Salvar posição </md-tooltip>
        </md-button>

        <div class="menu-divider"></div>

        <md-button
          class="md-icon-button md-list-action"
          @click="() => $router.back()"
        >
          <md-icon>arrow_back</md-icon>
          <md-tooltip md-direction="left"> Voltar </md-tooltip>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ComponenteTipo } from '@/utils/componente'

export default {
  name: 'ViewToolbar',
  data() {
    return {
      expanded: false,
      menuOpen: true,
      ComponenteTipo,
      x: 0,
      y: 0,
      // Largura da barra de rolagem vertical do scroller. Deslocamos o menu para
      // a esquerda por esse valor para a barra ficar visivel a DIREITA do menu,
      // com a lousa passando por tras (largura cheia, sem reservar espaco).
      railOffset: 0,
    }
  },
  watch: {
    menuOpen() {
      this.$nextTick(this.updateRailOffset)
    },
  },
  mounted() {
    this.startListenOverflow()
    this.$nextTick(this.updateRailOffset)

    // A barra de rolagem aparece/some conforme o conteudo transborda (ex: ao
    // arrastar um componente para fora da tela). Observamos o scroller para
    // reajustar o deslocamento do menu quando isso muda a largura util.
    const scroller = this.appScroller()
    if (scroller && window.ResizeObserver) {
      this.railObserver = new ResizeObserver(() => this.updateRailOffset())
      this.railObserver.observe(scroller)
    }
  },
  beforeDestroy() {
    this.stopListenOnverflow()
    if (this.railObserver) {
      this.railObserver.disconnect()
      this.railObserver = null
    }
  },
  methods: {
    selectItem(item) {
      this.$emit('selected', item)
    },
    appScroller() {
      // Scroller de conteudo da lousa (vue-material, modo fixed).
      return document.querySelector('.md-app-scroller')
    },
    updateRailOffset() {
      const scroller = this.appScroller()
      this.railOffset = scroller
        ? scroller.offsetWidth - scroller.clientWidth
        : 0
    },
    startListenOverflow() {
      document
        .getElementsByClassName(
          'md-app-container md-flex md-layout-column md-theme-default md-scrollbar'
        )[0]
        .addEventListener('scroll', this.changePosition)
    },
    stopListenOnverflow() {
      document
        .getElementsByClassName(
          'md-app-container md-flex md-layout-column md-theme-default md-scrollbar'
        )[0]
        .removeEventListener('scroll', this.changePosition)
    },
    changePosition() {
      const bodyRect = document.getElementById('main').getBoundingClientRect()

      this.x = bodyRect.x
      this.y = Math.abs(bodyRect.y)
    },
  },
}
</script>

<style lang="scss" scoped>
$rail_width: 100px;

.fixed-right {
  // Acima do control-box do moveable (3000) e do portal de vertices do cano
  // (9999), para o menu nunca ficar coberto pela alca de selecao.
  z-index: 10000;

  position: absolute;
  top: 0;
  right: 0;

  // Largura fixa em px: bate com os md-icon-button (~40px) e nao depende do
  // tamanho da tela, evitando overflow/desalinhamento.
  width: $rail_width;

  min-height: 100%;
  max-height: 100%;

  background-color: white;

  // Scrollbar so quando a lista nao cabe (antes era `scroll`, sempre visivel).
  overflow-x: hidden;
  overflow-y: auto;

  box-shadow: -2px 0 14px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);

  // Scrollbar fina e discreta (WebKit).
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 3px;
  }
}

.card-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 6px;
}

// Cabecalho em linha: titulo "Menu" + botao de recolher centralizados JUNTOS
// (justify-content: center), nao esticados com space-between. Assim a folga da
// esquerda fica igual a da direita e o espaco entre texto e icone fica pequeno.
.menu-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  h2 {
    margin: 0;
    font-size: 14px;
  }
}

.collapse-menu-button {
  margin: 0;
}

.menu-divider {
  width: 60%;
  height: 1px;
  margin: 6px auto;
  background-color: rgba(0, 0, 0, 0.08);
}

// Neutraliza a margem default do md-icon-button (o espacamento vem do `gap`)
// e adiciona hover discreto.
.card-slot .md-list-action {
  margin: 0;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }
}

.toggle-menu-button {
  z-index: 10000;
  position: absolute;
  top: 0;
  right: 0;
  margin: 8px;
  background-color: white;
  box-shadow: -2px 0 14px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);
}
</style>
